import React, { useState, useEffect } from 'react';
import axios from 'axios';
import FormTip from '../../commons/form_tip';
import { getCsrfToken } from '../../commons/authenticityToken';
import Select from 'react-select';
import LoadingOverlay from 'react-loading-overlay';

const Index = (props) => {
  axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();
  
  const [bedrockSetting, setBedrockSetting] = useState({ prompt_text: "", model_id: "", template_type: 1});
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loadBedrockPrompt();
  }, []);

  // テンプレート種別に変更があった場合に設定を取得し直す
  useEffect(() => {
    if (bedrockSetting.template_type) {
      loadBedrockPrompt();
    }
  }, [bedrockSetting.template_type]);

  const loadBedrockPrompt = () => {
    setIsLoading(true);
    axios.get('/api/internal/bedrock_settings/show', { params: { template_type: bedrockSetting.template_type }})
      .then(response => {
        setBedrockSetting(response.data.bedrock_setting);
      })
      .catch(error => {
        setErrorMessage(error.response?.data?.message || 'データの取得に失敗しました');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const updateBedrockPrompt = () => {
    setErrorMessage("");
    setSuccessMessage("");
    setIsLoading(true);
    
    axios.post('/api/internal/bedrock_settings/update', {
      bedrock_setting: bedrockSetting
    })
    .then(response => {
      setSuccessMessage(response.data.message);
    })
    .catch(error => {
      setErrorMessage(error.response?.data?.message || '更新に失敗しました');
    })
    .finally(() => {
      setIsLoading(false);
    });
  };

  const onChangeTemplateType = (template_type) => {
    setBedrockSetting({...bedrockSetting, template_type: template_type});
  };

  const onChangeModelId = (option) => {
    setBedrockSetting({...bedrockSetting, model_id: option["value"]})
  }

  return (
    <LoadingOverlay active={isLoading} spinner text="Loading...">
      {errorMessage && 
        <div className="alert alert-danger alert-dismissible" role="alert">
          <button 
            type="button"
            className="close"
            data-dismiss="alert"
            aria-label="閉じる">
            <span aria-hidden="true">×</span>
          </button>
          {errorMessage}
        </div>
      }
      
      {successMessage && 
        <div className="alert alert-success alert-dismissible" role="alert">
          <button 
            type="button"
            className="close"
            data-dismiss="alert"
            aria-label="閉じる">
            <span aria-hidden="true">×</span>
          </button>
          {successMessage}
        </div>
      }
      
      <div className="row">
        <div className="col-md-2 col-lg-3"/>
        <div className="col-xs-12 col-sm-12 col-md-8 col-lg-6">
          <h3>Bedrock設定</h3>
          <br/>
          <div className="form-group">
            <FormTip description="テンプレート種別を選択してください">
              <label>テンプレート種別</label>
              <span className="label label-danger ml5">必須</span>
            </FormTip>
            <div className="radio-inline">
              <input type="radio"
                     className="radio-input"
                     name="template_type"
                     value="1"
                     checked={bedrockSetting.template_type === 1}
                     onChange={() => onChangeTemplateType(1)}
                     id="template_type_1"/>
              <label className="m10" htmlFor="template_type_1">保険薬局向け</label>
              <input type="radio"
                     className="radio-input"
                     name="template_type"
                     value="2"
                     checked={bedrockSetting.template_type === 2}
                     onChange={() => onChangeTemplateType(2)}
                     id="template_type_2"/>
              <label className="m10" htmlFor="template_type_2">医療機関向け</label>
            </div>
          </div>
          <div className="form-group">
            <FormTip description="モデルIDを選択してください">
              <label htmlFor="model_id">モデルID</label>
              <span className="label label-danger ml5">必須</span>
            </FormTip>
              <Select
                id="m_institution_m_company_id"
                onChange={onChangeModelId}
                options={props.model_ids}
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder="モデルIDを選択してください"
                value={props.model_ids.find(model_id => model_id.value === bedrockSetting.model_id)}
              />
          </div>
          <div className="form-group">
            <FormTip description="プロンプトを入力してください。%{original_transcript_text}は文字起こし内容に変換されます。">
              <label htmlFor="prompt_content">プロンプト内容</label>
              <span className="label label-danger ml5">必須</span>
            </FormTip>
            <textarea 
              className="form-control" 
              rows={15}
              placeholder="プロンプト内容を入力してください"
              id="prompt_content"
              value={bedrockSetting?.prompt_text || ''}
              maxLength={100000}
              onChange={(e) => setBedrockSetting({...bedrockSetting, prompt_text: e.target.value})}
            />
          </div>

          <div className="actions mt40">
            <a className="btn btn-primary pull-right m5" onClick={updateBedrockPrompt}>
              更新する
            </a>
          </div>
        </div>   
      </div>
    </LoadingOverlay>
  );
};

export default Index;